import advancedSearch from './advanced-search'
import globalViewPages from './global_view_pages'
import partyEdit from './party-edit'
import teamPages from './team-pages'

export default [
  {
    path: '/',
    redirect: { name: 'dashboard' },
    meta: { requiresAuth: true },
    component: _ => import('@/views/Dashboard'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: { requiresAuth: true },
    component: _ => import('@/views/Dashboard'),
  },
  {
    path: '/data-recovery',
    name: 'data-recovery',
    meta: {
      requiresAuth: true,
      title: 'Data Recovery - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/DataRecovery'),
  },
  {
    path: '/import-party',
    name: 'import-party',
    meta: {
      requiresAuth: true,
      title: 'Import Party - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/ImportParty'),
  },
  {
    path: '/logs',
    name: 'logs',
    meta: {
      requiresAuth: true,
      title: 'Logs - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/Logs'),
  },
  {
    path: '/merge-party',
    name: 'merge-party',
    meta: {
      requiresAuth: true,
      title: 'Merge Party - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/MergeParty'),
  },
  {
    path: '/merge-party/:sourcePartyId',
    name: 'merge-party-with-source',
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Merge Party - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/MergeParty'),
  },
  {
    path: '/party-surveys',
    name: 'party-surveys',
    meta: {
      requiresAuth: true,
      title: 'Party Surveys - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/PartySurveys'),
  },
  {
    path: '/notifications',
    name: 'notifications',
    meta: { requiresAuth: true, title: 'Notifications - Innovation Law Lab Platform' },
    component: _ => import('@/views/Notifications'),
  },
  {
    path: '/notifications/:notificationId',
    name: 'goToNotification',
    meta: { requiresAuth: true, title: 'Notifications - Innovation Law Lab Platform' },
    component: _ => import('@/views/Notifications'),
  },
  {
    path: '/party/create',
    name: 'partyCreate',
    meta: { requiresAuth: true, title: 'Create Party - Innovation Law Lab Platform' },
    component: _ => import('@/views/PartyCreate'),
  },
  {
    path: '/party/create/record/:recordId/case/:caseId',
    name: 'partyCreateInCase',
    meta: { requiresAuth: true, title: 'Create Party - Innovation Law Lab Platform' },
    props: true,
    component: _ => import('@/views/PartyCreate'),
  },
  {
    path: '/party/:id',
    name: 'partyDisplay',
    meta: { requiresAuth: true },
    redirect: { name: 'pe-personal-details' },
  },
  partyEdit,
  {
    path: '/record/:id',
    name: 'record',
    meta: {
      requiresAuth: true,
      tmetric: { enabled: true },
    },
    component: _ => import('@/views/Record'),
  },
  {
    path: '/record/:id/case/:caseId',
    name: 'case',
    meta: {
      requiresAuth: true,
      tmetric: { enabled: true },
    },
    component: _ => import('@/views/Case'),
  },
  advancedSearch,
  {
    path: '/search',
    name: 'fastSearch',
    meta: { requiresAuth: true },
    component: _ => import('@/views/FastSearch'),
  },
  {
    path: '/resource-access-denied',
    name: 'resourceAccessDenied',
    meta: { requiresAuth: true, title: 'Access Denied - Innovation Law Lab Platform' },
    component: _ => import('@/views/ResourceAccessDeniedView'),
  },
  {
    path: '/resource-not-found',
    meta: { requiresAuth: true, title: 'Resource Not Found - Innovation Law Lab Platform' },
    props: { motif: null },
    component: () => import('@/views/ResourceNotFoundView'),
  },
  {
    path: '/resource-not-found/:motif',
    name: 'resourceNotFound',
    props: true,
    meta: { requiresAuth: true, title: 'Resource Not Found - Innovation Law Lab Platform' },
    component: _ => import('@/views/ResourceNotFoundView'),
  },
  {
    path: '/resource-requests',
    name: 'resourceRequests',
    meta: { requiresAuth: true, title: 'Resource Requests - Innovation Law Lab Platform' },
    component: _ => import('@/views/ResourceRequestsView'),
  },
  {
    path: '/page-not-found',
    name: 'pageNotFound',
    meta: { requiresAuth: true, title: 'Page Not Found - Innovation Law Lab Platform' },
    component: _ => import('@/views/PageNotFound'),
  },
  ...teamPages,
  ...globalViewPages,
]
